<app-dashboard-option [categories]="['COLUMNS']" [label]="'SIZE'" [information]="'PIXEL'">
  <div app-dashboard-option-content>
    <app-number [value]="dashboardLayout.size" (sendValue)="receiveValue($event)" [color]="color" [min]="10" [max]="100" [step]="10"></app-number>
  </div>
</app-dashboard-option>